<template>
  <div id="app" ref="app">
    <vue-progress-bar></vue-progress-bar>
    <router-view :key="$route.fullPath"/>
    <globalFooter></globalFooter>
  </div>
</template>

<script>
import globalFooter from '@/components/footer'
export default {
  name: 'App',
  components: {
    globalFooter
  }
}
</script>
<style>
@import url('https://fonts.googleapis.com/css?family=Ubuntu');
html, body {
  font-family: 'Ubuntu', sans-serif;
  height: 100%;
}
#app {
  /*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
  font-family: 'Ubuntu', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue